import { SxProps, Theme } from '@mui/material';
import { COLORS } from '../../Styles/Colors';

export const FORM = {
  borderRadius: '8px',
  fieldRadius: '6px',
  sectionGap: '28px',
  fieldGap: '16px',
  labelSize: '0.8125rem',
  hintSize: '0.75rem',
  border: '#e5e7eb',
  surface: '#f9fafb',
  text: '#374151',
  textMuted: '#6b7280',
} as const;

export const textFieldSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    borderRadius: FORM.fieldRadius,
    backgroundColor: COLORS.white,
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: COLORS.teal,
      boxShadow: `0 0 0 3px ${COLORS.teal}25`,
    },
    '&.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: COLORS.red,
      boxShadow: `0 0 0 3px ${COLORS.red}20`,
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: COLORS.teal,
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
    fontSize: FORM.hintSize,
  },
};

export const selectFocusSx: SxProps<Theme> = {
  borderRadius: FORM.fieldRadius,
  backgroundColor: COLORS.white,
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: FORM.border,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: COLORS.teal,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: COLORS.teal,
    boxShadow: `0 0 0 3px ${COLORS.teal}25`,
  },
};

export const checkboxSx: SxProps<Theme> = {
  color: FORM.border,
  '&.Mui-checked': {
    color: COLORS.teal,
  },
  '&.MuiCheckbox-indeterminate': {
    color: COLORS.teal,
  },
};

export const switchSx: SxProps<Theme> = {
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: COLORS.teal,
    '& + .MuiSwitch-track': {
      backgroundColor: COLORS.teal,
    },
  },
};
